import { useSelector } from "react-redux";
import React, { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { getRequestProjectProjection, putUpdateTaskByClickupSpace } from "../../../config";
import { columnsProjection } from "../../../types/columnsTables/columnsProjection";
import { iconsDetailsProyectMenu } from "../../../assets/icons/detailsProjectMenu";
import CardDetailProject from "../../../components/Card/CardDetailProject";
import { ModalMigration } from "../../../components/Modal/ModalMigration";
import { TableGeneral } from "../../../components/table/TableGeneral";
import { ButtonFab } from "../../../components/Buttons/ButtonFab";
import { MessageAnt } from "../../../redux/slices/ui/uiAction";
import { MessageType } from "../../../types/messageType";
import { useOpen } from "../../../hooks";

const legends = [
    {
        title: "Hora presupuesto",
        description: "Horas distribuidas de Desarrollo.",
    },
    {
        title: "Horas estimadas",
        description: "Horas que desarrollo estima utilizar en su backlog | Tiempo estimado",
    },
    {
        title: "Horas trabajadas",
        description: "Suma de horas trabajadas en clickup por área",
    },
    {
        title: "Horas extra",
        description: "Horas extras aprobadas laboradas por el equipo de desarrollo | Se cuentan al doble",
    },
    {
        title: "Recursos extra",
        description: "Suma de horas de recursos extras (assets - proveedores- servicios) que afectan el proyecto",
    },
    {
        title: "Total Horas consumidas",
        description: "Suma de horas trabajadas + horas extra + recursos extra",
    },
    {
        title: "Horas restantes",
        description: "Diferencia de total de horas consumidas vs. horas presupuesto",
    },
    {
        title: "Porcentaje de avance actual",
        description: "(Horas Consumidas x 100) / Hora presupuesto.",
    },
    {
        title: "Proyección en horas",
        description:
            "No. de horas totales que se requieren por área para concluir el proyecto. Depende del estatus de la tarea incluye total de horas consumidas + backlog restante de tareas no trabajadas.",
    },
    {
        title: "Porcentaje de proyección",
        description: "La proyección de consumo de recursos por área",
    },
];

export const PageProjection = () => {
    const [searchParams] = useSearchParams();
    const { columns, props } = columnsProjection();
    const [isLoading, setIsLoading] = useState(true);
    const [name, setName] = useState("del proyecto");
    const [openModal, setOpenModal] = useState(false);
    const [projectProjection, setProjectProjection] = useState([]);
    const [isUnlinked, setIsUnlinked] = useState(false);

    const { open, openMethod } = useOpen();
    const { isSuperAdmin } = useSelector((state) => state.auth);

    const migration = {
        text: "Migrar tiempos",
        img: iconsDetailsProyectMenu.cancelar,
        action: () => setOpenModal(true),
    }

    const getTableInformation = (project) => {
        const { timeAreas, timeProjectionAreas, percentage: percentageGeneral, } = project;
        const { total } = project.calculatedHours

        return Object.values(timeAreas).map(area => {
            const {
                name,
                field,
                timeTotalSpentArea = 0,
                timeTotalBacklogArea = 0,
                timeEstimated = 0,
                totalGeneral = 0,
                timeExtraResource = 0,
                timeExtraTime = 0,
                percentage = 0,
                substract = 0,
            } = area;
            const { percentage: percentageProjection, totalGeneral: totalGeneralProjection = 0 } = timeProjectionAreas[field];

            return {
                index: name,
                key: name,
                name,
                timeEstimated,
                timeTotalBacklogArea,
                timeTotalSpentArea,
                timeExtraResource,
                timeExtraTime,
                totalGeneral,
                substract,
                percentage,
                percentageProjection,
                totalGeneralProjection,
                timeEstimatedTotal: total,
                percentageProject: percentageGeneral
            }
        })
    }


    const fetchData = useCallback(async () => {
        try {
            const projectId = searchParams.get("project");
            if (!projectId) throw new Error("Project ID not found in searchParams");
            const { payload } = await getRequestProjectProjection(projectId);
            const newData = getTableInformation(payload);
            setProjectProjection(newData);
            setIsUnlinked(!!payload.isUnlink);
        } catch (error) {
            console.error("Error fetching data:", error);
            MessageAnt(MessageType.error, "No se obtuvieron correctamente los datos.")
        } finally {
            setIsLoading(false);
        }
    }, [searchParams])

    const updateTaskByClickup = async () => {
        setIsLoading(true);
        const projectId = searchParams.get("project");
        const { status } = await putUpdateTaskByClickupSpace({ clickupSpaces: [projectId] });
        if (status > 0) {
            MessageAnt(MessageType.error, "No se actualizo.")
            setOpenModal(false)
            setIsLoading(false)
            return
        }

        await fetchData()
        setOpenModal(false)
    }


    useEffect(() => {
        setName((name) => {
            const projectName = searchParams.get("name") || name;
            if (!projectName) throw new Error("Project name not found in searchParams");

            return projectName;
        });
    }, [searchParams]);

    useEffect(() => {
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchParams]);

    return (
        <div className="lg:p-12 p-4  w-full min-h-[calc(100vh-64px)]">
            <CardDetailProject title={`Proyección ${name}`}>
                <div className="w-full">
                    <TableGeneral state={projectProjection} column={columns} tableProps={props} loading={isLoading} />
                    <div className="pt-4">
                        <h2 className="text-base font-bold my-4">Leyendas</h2>
                        <div className="space-y-4 text-sm lg:columns-2">
                            {legends.map((legend, index) => (
                                <div key={`${index}-leg`}>
                                    <span className="font-bold">{legend.title}: </span>
                                    <span>{legend.description}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </CardDetailProject>
            {isSuperAdmin && !isUnlinked && (
                <ButtonFab
                    menuItems={[migration]}
                    actionActive={() => {
                        openMethod();
                    }}
                    valueOpen={open}
                />
            )}
            {openModal && <ModalMigration
                closeModal={() => {
                    setOpenModal(false)
                }}
                updateTask={updateTaskByClickup}
                loading={isLoading}
            />}
        </div>
    );
};
